import React, { Component, PureComponent } from 'react'
import { Link } from 'react-router-dom'
import { Icon } from 'semantic-ui-react'
import DataTable from '../datatable'

const opcos = {
  FI: 'FI',
  US: 'US',
  SE: 'SE',
  G: 'G',
}

const columns = [
  {
    name: 'name',
    label: 'Nimi',
    sortable: true,
    link(item) {
      return `/project/${item.get('id')}`
    },
  },
  {
    name: 'organization_id',
    label: 'Organisaatio',
    render(i) {
      return (
        <div className="tags">
          <Link to={`/organization?editId=${i.get('organization_id')}`} className="tags-item tags-item--purple">
            <Icon name="building" />
            {i.getIn(['organization', 'name'])}
          </Link>
        </div>
      )
    },
    export: i => i.getIn(['organization', 'name']),
  },
  {
    name: 'status',
    label: 'Status',
    options: {
      order: 'Tilaus',
      production: 'Tuotannossa',
      archive: 'Arkistoitu',
    },
  },
  {
    name: 'created_at',
    label: 'Luotu',
    date: 'DD.MM.YYYY - HH:mm',
    width: 200,
    sortable: true,
    defaultSort: true,
  },
  {
    name: 'edit',
    label: '',
    width: 120,
    id: true,
    render() {
      return <span>Muokkaa</span>
    },
  },
  {
    name: 'productionNotificationsEnabled',
    label: 'Autoviestit',
    render(project) {
      if (project.getIn(['data', 'productionNotificationsEnabled']))
        return <span className="tags-item tags-item--green">Päällä</span>

      return <span className="tags-item tags-item--grey">Ei päällä</span>
    },
  },
  {
    name: 'operating_company_id',
    label: 'Opco',
  },
]

const filterFields = [
  {
    name: 'status',
    type: 'buttons',
    label: 'Tila',
    multiple: true,
    options: [
      { value: 'pending', label: 'Odottaa' },
      { value: 'production', label: 'Tuotannossa' },
      { value: 'archive', label: 'Arkistoitu' },
    ],
  },
  {
    type: 'group',
    placeholder: 'OPCO',
    icon: 'building',
    fields: [
      {
        name: 'operating_company_id',
        type: 'checkboxes',
        label: 'OPCO',
        options: Object.keys(opcos).map(key => ({ value: key, label: opcos[key] })),
      },
    ],
  },
]

export default function ProjectRoot() {
  return (
    <DataTable
      id="projects"
      entity="project"
      crud
      filters
      filterFields={filterFields}
      defaultFilters={{ status: ['pending', 'production'] }}
      title="Projektit"
      texts={{ createButton: 'Lisää projekti' }}
      sortDir="desc"
      columns={columns}
    />
  )
}
